import { Heading2 } from 'components/shared/Typography';
import { useI18n } from 'hooks/useI18n';
import { useRouter } from 'next/dist/client/router';
import { StatsItem } from '../../CompaniesComponent.types';
import {
  StyledContainer,
  StyledDataItem,
  StyledDataList,
  StyledDataValue,
  StyledHeader,
  StyledWrapper
} from './Data.styled';

type ContentProps = {
  stats: StatsItem[];
  manfreditesCount: number;
  className?: string;
};

const Data: React.FC<ContentProps> = ({
  stats,
  manfreditesCount,
  className
}) => {
  const { t } = useI18n('companies2');
  const { locale } = useRouter();

  const currentStats = stats[0];

  const data = [
    {
      value: manfreditesCount.toLocaleString(locale),
      key: t('companies.data.professionals')
    },
    {
      value: currentStats?.attributes
        ? currentStats.attributes.successRate + '%'
        : null,
      key: t('companies.data.success_rate')
    },
    {
      value: currentStats?.attributes
        ? currentStats.attributes.timeToHire
        : null,
      key: t('companies.data.time_to_hire')
    },
    {
      value: currentStats?.attributes
        ? '+' + currentStats.attributes.positionsCount.toLocaleString(locale)
        : null,
      key: t('companies.data.positions')
    },
    {
      value: currentStats?.attributes
        ? currentStats.attributes.customerScore.toLocaleString(locale)
        : null,
      key: t('companies.data.customer_score')
    },
    {
      value: currentStats?.attributes
        ? '+' + currentStats.attributes.companiesCount.toLocaleString(locale)
        : null,
      key: t('companies.data.companies')
    }
  ];

  return (
    <StyledWrapper className={className}>
      <StyledContainer>
        <StyledHeader>
          <Heading2>{t('companies.data.title')}</Heading2>
        </StyledHeader>
        <StyledDataList>
          {data.map((item, index) => (
            <StyledDataItem key={index}>
              <StyledDataValue>{item.value}</StyledDataValue>
              <p>{item.key}</p>
            </StyledDataItem>
          ))}
        </StyledDataList>
      </StyledContainer>
    </StyledWrapper>
  );
};

export default Data;
